/**
 * Bravik Theme Core JavaScript
 * Modern Egyptian Essentials — "Lead, Don't Follow"
 */

document.addEventListener('DOMContentLoaded', () => {
  initMobileNav();
  initAccordions();
  initSizeGuideModal();
  initStickyHeader();
  initStickyMobileATC();
});

// Global Namespace
window.Bravik = window.Bravik || {};

// Toast notification helper
window.Bravik.showToast = function(message) {
  const toast = document.querySelector('.toast-notification');
  if (!toast) return;
  const msgEl = toast.querySelector('.toast-message');
  if (msgEl) msgEl.textContent = message;
  toast.classList.add('is-visible');
  setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 3500);
};

// Format currency
window.Bravik.formatMoney = function(cents) {
  const amount = (cents / 100).toFixed(0);
  return amount + ' EGP';
};

// Mobile Navigation Drawer with full accessibility & focus management
function initMobileNav() {
  const drawer = document.querySelector('.mobile-nav-drawer');
  const openBtn = document.querySelector('[data-open-mobile-nav]');
  const closeBtns = document.querySelectorAll('[data-close-mobile-nav]');
  const backdrop = document.querySelector('.mobile-nav-backdrop');

  if (!drawer || !openBtn) return;

  let lastActiveElement = null;

  function openNav() {
    lastActiveElement = document.activeElement;
    drawer.classList.add('is-open');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-nav-open');

    // Focus close button inside drawer for screen readers
    const closeBtn = drawer.querySelector('.mobile-nav-close-btn');
    if (closeBtn) {
      setTimeout(() => closeBtn.focus(), 50);
    }
  }

  function closeNav() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-nav-open');

    // Restore focus to triggering hamburger button
    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      lastActiveElement.focus();
    } else {
      openBtn.focus();
    }
  }

  openBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (drawer.classList.contains('is-open')) {
      closeNav();
    } else {
      openNav();
    }
  });

  closeBtns.forEach(btn => btn.addEventListener('click', (e) => {
    // If it's a link, allow navigation while closing drawer
    closeNav();
  }));

  if (backdrop) {
    backdrop.addEventListener('click', closeNav);
  }

  // Keyboard navigation: Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeNav();
    }
  });

  // Close drawer when any navigation link inside is clicked
  drawer.querySelectorAll('.mobile-nav-links a').forEach(link => {
    link.addEventListener('click', () => {
      closeNav();
    });
  });
}

// Accordion Toggles
function initAccordions() {
  const accordionTriggers = document.querySelectorAll('.accordion-trigger');

  accordionTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      if (!item) return;
      const isOpen = item.classList.contains('is-open');
      
      const parent = item.parentElement;
      if (parent && parent.dataset.singleAccordion === 'true') {
        parent.querySelectorAll('.accordion-item').forEach(el => el.classList.remove('is-open'));
      }

      if (isOpen) {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

// Size Guide Modal
function initSizeGuideModal() {
  const modal = document.querySelector('.size-guide-modal');
  const triggers = document.querySelectorAll('[data-open-size-guide]');
  const closeBtns = document.querySelectorAll('[data-close-size-guide]');
  const backdrop = document.querySelector('.size-guide-backdrop');

  if (!modal) return;

  let lastActiveEl = null;

  function openModal(e) {
    if (e) e.preventDefault();
    lastActiveEl = document.activeElement;
    modal.classList.add('is-open');
    document.body.classList.add('modal-open');
    const closeBtn = modal.querySelector('.modal-header button');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.classList.remove('modal-open');
    if (lastActiveEl) lastActiveEl.focus();
  }

  triggers.forEach(btn => btn.addEventListener('click', openModal));
  closeBtns.forEach(btn => btn.addEventListener('click', closeModal));
  if (backdrop) backdrop.addEventListener('click', closeModal);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
}

// Sticky Header Behavior
function initStickyHeader() {
  const headerWrapper = document.querySelector('.site-header-wrapper.sticky-header');
  if (!headerWrapper) return;

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > 60) {
      headerWrapper.classList.add('is-scrolled');
    } else {
      headerWrapper.classList.remove('is-scrolled');
    }
  }, { passive: true });
}

// Sticky Mobile ATC
function initStickyMobileATC() {
  const stickyATC = document.querySelector('.sticky-mobile-atc');
  const mainATC = document.querySelector('.product-form-actions .btn-add-to-cart');
  if (!stickyATC || !mainATC) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        stickyATC.classList.add('is-visible');
      } else {
        stickyATC.classList.remove('is-visible');
      }
    });
  }, { threshold: 0 });

  observer.observe(mainATC);

  const stickyBtn = stickyATC.querySelector('.btn-sticky-trigger');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      mainATC.scrollIntoView({ behavior: 'smooth', block: 'center' });
      mainATC.click();
    });
  }
}
